export class UnauthorizedError extends Error {
  constructor() {
    super('Not authorized to do this action')
    this.name = 'UnauthorizedError'
  }
}
